export default __webpack_public_path__ + "icon_filter.aab6d14e7b9dc3f4b11ed986d6976251.svg";